import { getPlayerById } from '../state/selectors';
import { destroyFromHand } from '../cards/effectHelpers';
import { endTurn } from './turnActions';

// Destroys exactly one chosen hand card (removed from the game entirely - not
// discarded); the rest of hand is discarded as part of endTurn's normal
// cleanup. Used to thin an unwanted card (e.g. a curse) from the deck
// (rulebook, "Rest"). Goes through destroyFromHand rather than inlining its
// own hand-filter, so it picks up that helper's equippedWeapons cleanup and
// stats.cardsDestroyed counting for free - Rest can target an equipped
// weapon just like any other destroy effect can.
export function rest(state, { playerId, instanceIdToDestroy }) {
  const player = getPlayerById(state, playerId);
  if (!player.hand.includes(instanceIdToDestroy)) {
    throw new Error('Can only rest-destroy a card that is in hand.');
  }
  const destroyed = destroyFromHand(state, playerId, instanceIdToDestroy);
  const players = destroyed.players.map((p) => (p.id === playerId
    ? { ...p, stats: { ...p.stats, timesRested: p.stats.timesRested + 1 } }
    : p));
  return endTurn({ ...destroyed, players });
}
